export default __webpack_public_path__ + "static/media/Physical-Properties_A4.914707d6.pdf";